import { I18n } from "i18n-js";
import { translations } from "./localizations";
import { privacyPolicyContent } from "./privacyPolicyContent";


Object.keys(privacyPolicyContent).forEach((locale) => {
  translations[locale] = {
    ...translations[locale],
    ...privacyPolicyContent[locale],
  };
});

const i18n = new I18n(translations);
i18n.defaultLocale = 'en-US';
i18n.locale = navigator.language ?? 'en-US';
i18n.enableFallback = true;

export default i18n;